export enum TerminologyForm {
  Singular,
  Plural
}